import { apiGateway } from "@/shared/apiGateway";

const getQuoteListing = (context, { filterCriteria, searchCriteria }) => {
  var url = "api/quotes";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (filterCriteria.contractorRegionId !== "0") {
    url = url + "&contractorRegionId=" + filterCriteria.contractorRegionId;
  }
  if (filterCriteria.quoteTypeId !== 0) {
    url = url + "&quoteType=" + filterCriteria.quoteTypeId;
  }
  if (
    filterCriteria.quoteStatusId !== 0 &&
    filterCriteria.quoteStatusId !== undefined
  ) {
    url = url + "&quoteStatus=" + filterCriteria.quoteStatusId;
  } else {
    url = url + "&quoteGroup=" + filterCriteria.quoteGroup;
  }
  if (filterCriteria.quotePriorityId > 0) {
    url = url + "&quotePriority=" + filterCriteria.quotePriorityId;
  }

  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      return context.commit("Set_Quotes", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Quotes"], {
        root: true
      });
    });
};

const getQuoteDetail = (context, quoteId) => {
  return apiGateway
    .apiGatewayGET("api/quotes/" + quoteId)
    .then(data => {
      context.commit("Set_Quote", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Quote"], {
        root: true
      });
    });
};

const updateQuoteStatus = (commit, quoteStatus) => {
  quoteStatus.noteType = 2;
  return apiGateway
    .apiGatewayPATCH("api/Quotes/update-quote-status/", quoteStatus)
    .then(data => {
      return data;
    });
};

const createQuoteNote = (commit, body) => {
  body.noteType = 1;
  return apiGateway.apiGatewayPATCH("api/quotes/update-quote-notes", body);
};

export default {
  getQuoteListing,
  getQuoteDetail,
  updateQuoteStatus,
  createQuoteNote
};
